export class ProductInventoryAttributeTypeCommandModel {
    public productInventoryAttributeTypeId: string;
    public productAttributeTypeCode: string;
    public displaySequence: number; 
}
 